export const FETCH_TRIP_BEGIN = 'FETCH_TRIP_BEGIN';
export const FETCH_TRIP_SUCCESS = 'FETCH_TRIP_SUCCESS';
export const FETCH_TRIP_FAILURE = 'FETCH_TRIP_FAILURE';
